import gql from 'graphql-tag';

export const GET_TAGS_CONFIGURATION = gql`
query getTagsConfiguration {
    getTagsConfiguration{
     tags {
       tagName
     }
   }
 }
`;
